export default "__VITE_ASSET__0a640455__"